<template>
  <div
    v-if="!isEmpty"
    class="field-container"
    :class="{ 'df-error': error, 'field-disabled': disabled }"
  >
    <!-- eslint-disable-next-line vue/no-v-html -->
    <span class="field-label" v-html="text"></span>
    <span v-if="button" class="field-button">
      <span v-if="!buttonOn" @click="change(true)">{{ button.off }}</span>
      <span v-if="buttonOn" @click="change(false)">{{ button.on }}</span>
    </span>
  </div>
</template>

<script>
/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
export default {
  name: 'DfHeader',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    button: {
      type: Object,
      default: undefined,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      buttonOn: this.value,
    };
  },
  computed: {
    isEmpty() {
      return /^\s*$/.test(this.text);
    },
  },
  methods: {
    change(value) {
      this.$emit('input', (this.buttonOn = value));
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";

$color-blackhole: map.get(colors.$baseColors, blackhole);
$color-error: map.get(colors.$baseColors, 'color-error');
$color-gandalf: map.get(colors.$baseColors, gandalf);
$color-gray-2D: #2d2d2d;

.field-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.field-label {
  @include global.heading-4();
  color: $color-blackhole;
}

.field-button {
  @include global.p-small-bold();

  cursor: pointer;
  color: $color-gray-2D;
  text-align: right;
  text-transform: uppercase;
}

.field-disabled {
  pointer-events: none;

  .field-label {
    color: $color-gandalf;
  }

  .field-button {
    color: $color-gandalf;
  }
}

.df-error {
  .field-label {
    color: $color-error;
  }

  .field-button {
    color: $color-error;
  }
}
</style>
